// 模拟API响应延迟
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 模拟用户数据
const mockUsers = [
  {
    id: 1,
    username: 'admin',
    password: '123456',
    name: '管理员',
    role: 'admin',
    token: 'admin-token-123'
  },
  {
    id: 2,
    username: 'merchant',
    password: '123456',
    name: '商户',
    role: 'merchant',
    token: 'merchant-token-456'
  }
];

export default {
  // 登录接口
  async login(params) {
    await delay(300);
    const { username, password } = params;

    const user = mockUsers.find(u => u.username === username && u.password === password);

    if (user) {
      return {
        code: 200,
        data: {
          id: user.id,
          name: user.name,
          role: user.role,
          token: user.token
        }
      };
    } else {
      return {
        code: 401,
        message: '用户名或密码错误'
      };
    }
  },

  // 获取商户信息
  async getMerchantInfo() {
    await delay(300);
    return {
      code: 200,
      data: {
        name: '测试商户',
        balance: 10000,
        status: 1
      }
    };
  },

  // 获取管理员信息
  async getAdminInfo() {
    await delay(300);
    return {
      code: 200,
      data: {
        name: '管理员',
        role: 'admin',
        permissions: ['all']
      }
    };
  }
};
